
<div class="home-page">
  <!-- Imagen fullscreen reemplazando el Swiper -->
  <div class="hero-image">
    <img src="assets/images/SN_Day.png" alt="Banner Inmobiliaria Primo" class="hero-img">

    <!-- Filtro superpuesto -->
    <app-filter (search)="getSearch($event)"></app-filter>
  </div>
</div>

<div class="container">
  <hr class="featurette-divider">
  <div class="row featurette">
    <div class="col-md-12">
      <h2 class="featurette-heading">Nuestros servicios.</h2>
    </div>
  </div>

  <div class="row row-cols-2 row-cols-md-3 g-3 mt-3">
    <div class="col">
      <div class="card h-100" style="text-align: center; border: none;">
        <span><i class="fas fa-home" style="font-size: 6em; color: #df3230;"></i></span>
        <span>Venta</span>
      </div>
    </div>
    <div class="col">
      <div class="card h-100" style="text-align: center; border: none;">
        <span><i class="fas fa-store-alt" style="font-size: 6em; color: #df3230;"></i></span>
        <span>Alquiler</span>
      </div>
    </div>
    <div class="col">
      <div class="card h-100" style="text-align: center; border: none;">
        <span><i class="fas fa-calculator" style="font-size: 6em; color: #df3230;"></i></span>
        <span>Tasación</span>
      </div>
    </div>
    <div class="col">
      <div class="card h-100" style="text-align: center; border: none;">
        <span><i class="fas fa-user-tie" style="font-size: 6em; color: #df3230;"></i></span>
        <span>Asesoramiento</span>
      </div>
    </div>
    <div class="col">
      <div class="card h-100" style="text-align: center; border: none;">
        <span><i class="fas fa-hand-holding-usd" style="font-size: 6em; color: #df3230;"></i></span>
        <span>Administración</span>
      </div>
    </div>
    <div class="col">
      <div class="card h-100" style="text-align: center; border: none;">
        <span><i class="fas fa-chart-line" style="font-size: 6em; color: #df3230;"></i></span>
        <span>Inversiones</span>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <hr class="featurette-divider">
  <div class="row featurette">
    <div class="col-md-12">
      <h2 class="featurette-heading">Últimos Ingresos - <span class="text-muted">Venta y Alquiler.</span></h2>
      <p class="lead">Aquí encontrarás las últimas propiedades ingresadas en Venta y Alquiler</p>
    </div>
  </div>

  <app-card [propiedades]="propiedades"></app-card>
</div>
